import {
    child,
    DataSnapshot,
    get,
    push,
    ref,
    serverTimestamp,
    set,
} from 'firebase/database'
import { db } from '../../firebase/configs'
import dayjs from '../../helpers/dayjs'
import { getIP } from '../../helpers/getIp'
import { logger } from '../../helpers/logger'
import { PrincipalReferenceResponse } from './components/SurveySteps/components/SurveyForm/schema'

const baseRef = ref(db, `referenceReviewPrincipal`)

export const getSurvey = (requestId: string): Promise<DataSnapshot> =>
    get(child(baseRef, requestId))

export const recordVisit = async (requestId: string) =>
    await push(child(baseRef, `${requestId}/visited`), {
        timeStamp: dayjs().unix(),
        appVersion: process.env.REACT_APP_VERSION || 'unknown',
    })

export const denySubmission = async (requestId: string) => {
    let ip: string | null
    try {
        ip = await getIP()
    } catch (e) {
        logger.warn(`Failed to get IP`)
        ip = null
    }

    await set(child(baseRef, `${requestId}/response`), {
        ip,
        timeResponded: serverTimestamp(),
        state: 'declined',
    })
    return Promise.resolve()
}

export const submitResponse = async (
    requestId: string,
    response: PrincipalReferenceResponse
) => {
    let ip: string | null
    try {
        ip = await getIP()
    } catch (e) {
        logger.warn(`Failed to get IP`)
        ip = null
    }

    const responseRef = child(baseRef, `${requestId}/response`)

    await set(responseRef, {
        version: 1,
        state: 'submitted',
        ip,
        timeResponded: serverTimestamp(),
        data: response,
    })
    return Promise.resolve()
}
